module.exports = __webpack_public_path__ + "img/patient-record-mobile-ru.6e6f53c2.jpg";